import { TBaseRequest } from '../types';

export type TDiiaSignInStore = {
  deepLink: string;
  dynamicLink: string;
  requestId: string;
  loading: boolean;
  status: string;
  error: string | null;
};

export type TDiiaInitializeResponse = {
  deeplink: string;
  dynamicLink: string;
  requestId: string;
};

export type TDiiaGetStatusResponse = {
  status: DiiaStatuses | DiiaFinalStatuses;
};

export type TDiiaInitializeAssetManagerRequest = TBaseRequest & {
  managerId: number | string;
};

export type TDiiaGetStatusAssetManagerRequest = TDiiaInitializeAssetManagerRequest & {
  requestId: string;
};

export type TDiiaGetStatusRequest = TBaseRequest & {
  requestId: string;
};

export type TDiiaGetFinalStatusVerificationRequest = TBaseRequest & {
  requestId: string;
  identificationNumber: string;
  toboId: string;
  userId?: string;
  clientType: string;
};

export type TDiiaGetFinalStatusAssetManagerRequest = TDiiaGetStatusAssetManagerRequest;

export enum DiiaStatuses {
  processing = 'processing',
  done = 'done',
  refuse = 'refuse',
  rejected = 'rejected',
  canceled = 'canceled',
  notUsed = 'notUsed',
}

export enum DiiaFinalStatuses {
  success = 'SUCCESS',
}
